export const retryAttempts = 3;
